export default "__VITE_ASSET__c4baba08__"